import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormlySelectModule as FormlyCoreSelectModule } from '@ngx-formly/core/select';

import { FormlyFieldSelect } from './select.type';
import { FormlyFormFieldModule } from '../form-field/public_api';

@NgModule({
    declarations: [FormlyFieldSelect],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DropDownsModule,

        FormlyFormFieldModule,
        FormlyCoreSelectModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'kendo-select',
                    component: FormlyFieldSelect,
                    wrappers: ['simple-form-field'],
                    //wrappers: ['kendo-form-field'],
                    defaultOptions: {
                        props: {
                            options: []
                        }
                    }
                },
                { name: 'kendo-enum', extends: 'kendo-select' }
            ],
        }),
    ],
})
export class FormlySelectModule { }
